import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

// Migrate legacy localStorage keys (hrafti_* -> khadam_*)
const migrateLegacyKeys = () => {
  try {
    const legacyToken = localStorage.getItem('hrafti_token');
    const legacyUser = localStorage.getItem('hrafti_user');
    if (legacyToken && !localStorage.getItem('khadam_token')) {
      localStorage.setItem('khadam_token', legacyToken);
    }
    if (legacyUser && !localStorage.getItem('khadam_user')) {
      localStorage.setItem('khadam_user', legacyUser);
    }
    localStorage.removeItem('hrafti_token');
    localStorage.removeItem('hrafti_user');
  } catch (e) {}
};
migrateLegacyKeys();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('khadam_token'));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('khadam_user');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem('khadam_user');
      }
    }
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const res = await authAPI.login({ email, password });
      const { user: userData, token: authToken } = res.data;
      setUser(userData);
      setToken(authToken);
      localStorage.setItem('khadam_token', authToken);
      localStorage.setItem('khadam_user', JSON.stringify(userData));
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Erreur de connexion' };
    } finally {
      setLoading(false);
    }
  };

  const register = async (data) => {
    setLoading(true);
    try {
      const res = await authAPI.register(data);
      const { user: userData, token: authToken } = res.data;
      setUser(userData);
      setToken(authToken);
      localStorage.setItem('khadam_token', authToken);
      localStorage.setItem('khadam_user', JSON.stringify(userData));
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Erreur d\'inscription' };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('khadam_token');
    localStorage.removeItem('khadam_user');
  };

  const setAuth = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem('khadam_token', authToken);
    localStorage.setItem('khadam_user', JSON.stringify(userData));
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, setAuth, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
